import React from "react";
import { useTranslation } from "react-i18next";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import ButtonVariant from "app/components/Button/ButtonVariant";

import styles from "./styles.module.scss";

type CancelPurchaseConfirmationModalProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
  title?: string;
  message?: React.ReactNode;
  hideCancel?: boolean;
  confirmLabel?: string;
};

export default function CancelPurchaseConfirmationModal(props: CancelPurchaseConfirmationModalProps) {
  const { isOpen, onConfirm, onCancel, isLoading, title, message, hideCancel, confirmLabel } = props;
  const { t } = useTranslation();

  const displayTitle = title || t("Cancel Registration");
  const displayMessage = message || t("Please confirm that you would like to cancel your registration.");

  return (
    <ModalLayout isOpen={isOpen} classNames={styles.modal}>
      <div className={styles.confirmation_modal_content}>
        <div className={styles.title_and_content}>
          <div className={styles.title}>
            <i className={`ico ico-x ${styles.warning}`} />
            <h2>{displayTitle}</h2>
          </div>
          <p className={styles.message}>
            {displayMessage}
          </p>
          <div className={styles.actions}>
            <ButtonVariant
              buttonType="secondary-outline-danger"
              title={confirmLabel || t("Confirm")}
              onClickFunc={onConfirm}
              disabled={isLoading}
            />
            {!hideCancel && (
              <ButtonVariant
                buttonType="secondary-outline"
                title={t("Cancel")}
                onClickFunc={onCancel}
                disabled={isLoading}
              />
            )}
          </div>
        </div>
      </div>
    </ModalLayout>
  );
}
